// import React, { useEffect, useState } from 'react';
// import { Document, Page, Text, View, Image, StyleSheet, Font, PDFViewer, Link } from '@react-pdf/renderer';

// // Define styles
// const styles = StyleSheet.create({
//     page: {
//         backgroundColor: '#FFFFFF',
//         position: 'relative'
//     },
//     loyaltyContainer: {
//         position: 'absolute', // Position the container absolutely
//         right: 0, // Align to the right by 5%
//         top: '45%', // Position from the top by 45%
//         transform: 'rotate(-90deg)',
//         display: 'flex', // Enable flexbox layout
//         flexDirection: 'row', // Arrange content in a row (you can change to 'column' if needed)
//         alignItems: 'center', // Center items vertically
//         justifyContent: 'center', // Center items horizontally
//     },
//     loyaltyPointsImage: {
//         width: 50, // Set image width
//         height: 50, // Set image height
//         marginRight: 10, // Add spacing between the image and text
//     },
//     loyaltyPoints: {
//         fontSize: 16, // Adjust text size
//         color: '#FFFFFF', // Set text color (black, adjust as needed)
//         fontWeight: 'bold', // Make text bold
//     },
//     firstPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundColor: '#5b5f62',
//     },
//     firstPageTopRoundOne: {
//         position: 'absolute',
//         top: '-200px',
//         left: '-520px',
//         width: '700px',
//         height: '700px',
//         borderRadius: '100%',
//         border: '4px solid #728478'
//     },
//     firstPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-300px',
//         left: '-500px',
//         width: '700px',
//         height: '700px',
//         borderRadius: '100%',
//         border: '2.5px solid #728478'
//     },
//     firstPageTopRoundThree: {
//         position: 'absolute',
//         top: '-270px',
//         left: '-600px',
//         width: '750px',
//         height: '750px',
//         borderRadius: '100%',
//         // backgroundColor:'blue',
//         border: '2px solid #728478'
//     },
//     firstPageUpperLeftContainer: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '65%',
//         height: '70%',
//         backgroundColor: '#e4d0c5',
//         display: 'flex',
//         justifyContent: 'flex-end',
//         alignItems: 'flex-end'
//     },
//     firstPageMainImageContainer: {
//         height: '85%',
//         width: '85%',
//         border: '10px solid white'
//     },
//     firstPageMainImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     logoImageContainer: {
//         position: 'relative',
//         top: '10%',
//         left: '80%',
//         width: '20%',
//         height: '8%',
//         backgroundColor: '#e4d0c5',
//         padding: '2px',
//         display: 'flex',
//         justifyContent: 'center',
//         alignContent: 'center',
//         alignItems: 'center',
//     },
//     logoImage: {
//         width: '70%',
//         height: 'auto',
//         objectFit: 'cover',
//         marginLeft: '15%'
//     },
//     firstPageUpperContainer: {
//         position: 'absolute',
//         top: 0,
//         right: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '60%',
//         height: '10%',
//     },
//     firstPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '80%',
//         position: 'absolute',
//         top: '10%',
//         left: '10%',
//     },

//     firstPageContentBox: {
//         position: 'absolute',
//         bottom: '10%',
//         left: '10%',
//         width: '80%',
//         height: '30%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: "space-evenly",
//         alignItems: 'left',
//         margin: 'auto',

//     },
//     greetingContainer: {
//         position: 'absolute',
//         left: '40%',
//         top: '20%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px 80px 10px 10px'

//     },

//     greeting: {
//         fontSize: 35,
//         fontWeight: 'bold'
//     },
//     customerNameContainer: {
//         position: 'absolute',
//         left: '40%',
//         top: '28%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px 10px 10px 10px'
//     },
//     customerName: {
//         fontSize: 40,
//         fontWeight: 'bold',
//     },
//     customerMessageContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '75%',
//         color: 'white',
//         width: '35%',
//         height: '20%',
//     },
//     customerMessage: {
//         fontSize: 15,
//     },
//     firstPageBottomRightContainer: {
//         position: 'absolute',
//         bottom: 0,
//         right: 0,
//         backgroundColor: '#728478',
//         width: '50%',
//         height: '35%',
//     },
//     firstPageBottomShapeContainer: {
//         // position: 'absolute',
//         // bottom: '-110px',
//         // right: '-60px',
//         // width: '50%',
//         // height: '40%',
//         position: 'absolute',
//         bottom: '-80px',
//         right: '-150px',
//         width: '70%',
//         height: '25%',
//         transform: 'rotate(180deg)',

//     },
//     firstPageBottomRoundOne: {
//         position: 'absolute',
//         bottom: '-260px',
//         right: '-350px',
//         width: '500px',
//         height: '500px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     firstPageBottomRoundTwo: {
//         position: 'absolute',
//         bottom: '-460px',
//         right: '-390px',
//         width: '700px',
//         height: '700px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     // For Second Page =>

//     secondPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundColor: '#efe6dc',
//     },
//     secondPageTopContainer: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '80%',
//         height: '60%',
//         backgroundColor: '#728478',
//     },
//     secondPageImageContainer: {
//         position: 'relative',
//         left: '10%',
//         top: '10%',
//         width: '60%',
//         height: '60%',
//         border: '10px solid #efe6dc'

//     },
//     secondPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     secondPageProductPriceContainer: {
//         position: 'absolute',
//         right: '5%',
//         top: '30%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'

//     },

//     secondPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     secondPageBottomContentContainer: {
//         position: 'absolute',
//         top: '72%',
//         left: '10%',
//         width: '50%',
//         height: '25%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     secondPageProductName: {
//         fontSize: 25,
//     },
//     secondPageProdutDescription: {
//         fontSize: 15,
//     },
//     secondPageBottomRoundOne: {
//         position: 'absolute',
//         top: '-350px',
//         left: '-500px',
//         width: '1100px',
//         height: '1100px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     secondPageBottomRoundTwo: {
//         position: 'absolute',
//         top: '-350px',
//         left: '-100px',
//         width: '900px',
//         height: '900px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     secondPageTopUpperContainer: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '50%',
//         height: '30%',
//         backgroundColor: '#5b6066'

//     },

//     // For third Page =>
//     thirdPageLeftBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '40%',
//         height: '100%',
//         backgroundColor: '#efe6dc',
//     },
//     thirdPageRightBackground: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         width: '60%',
//         height: '100%',
//         backgroundColor: '#c4ad95',
//     },
//     thirdPageImageContainer: {
//         position: 'relative',
//         left: '50%',
//         top: '10%',
//         width: '40%',
//         height: '50%',
//         border: '10px solid #efe6dc'
//     },
//     thirdPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     thirdPageProductPriceContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '30%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     thirdPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     thirdPageBottomContentContainer: {
//         position: 'absolute',
//         top: '65%',
//         left: '10%',
//         width: '60%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     thirdPageProductName: {
//         fontSize: 25,
//     },
//     thirdPageProdutDescription: {
//         fontSize: 15,
//     },
//     thirdPageBottomRoundOne: {
//         position: 'absolute',
//         bottom: '-350px',
//         right: '-670px',
//         width: '1100px',
//         height: '1100px',
//         borderRadius: '100%',
//         border: '2px solid #728478'

//     },
//     thirdPageBottomRoundTwo: {
//         position: 'absolute',
//         bottom: '-400px',
//         right: '-2000px',
//         width: '2200px',
//         height: '2200px',
//         borderRadius: '100%',
//         border: '5px solid #728478'
//     },
//     thirdPageBottomShapeContainer: {
//         position: 'absolute',
//         bottom: '-250px',
//         left: '25%',
//         width: '50%',
//         height: '40%',
//         transform: 'rotate(70deg)',
//     },

//     // For fourth Page =>
//     fourthPageTopBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '50%',
//         backgroundColor: '#efe6dc',
//     },
//     fourthPageBottomBackground: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         width: '100%',
//         height: '50%',
//         backgroundColor: '#c4ad95',
//     },
//     fourthPageImageContainer: {
//         position: 'relative',
//         left: '10%',
//         top: '10%',
//         width: '92%',
//         height: '50%',
//         border: '10px solid #efe6dc'
//     },
//     fourthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     fourthPageProductPriceContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '20%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     fourthPageProductNameContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '30%',
//         width: '80%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     fourthPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     fourthPageProdutDescriptionContainer: {
//         position: 'absolute',
//         top: '65%',
//         left: '10%',
//         width: '80%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center'
//     },
//     fourthPageProductName: {
//         fontSize: 25,
//     },
//     fourthPageProdutDescription: {
//         fontSize: 15,
//     },
//     fourthPageTopRoundOne: {
//         position: 'absolute',
//         top: '-400px',
//         right: '-750px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     fourthPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-450px',
//         right: '-650px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     fourthPageBottomRoundOne: {
//         position: 'absolute',
//         bottom: '-350px',
//         left: '-670px',
//         width: '1100px',
//         height: '1100px',
//         borderRadius: '100%',
//         border: '2px solid #728478',
//     },
//     fourthPageBottomRoundTwo: {
//         position: 'absolute',
//         bottom: '-300px',
//         left: '-250px',
//         width: '700px',
//         height: '600px',
//         borderRadius: '100%',
//         border: '5px solid #728478',
//     },
//     fourthPageBottomShapeContainer: {
//         position: 'absolute',
//         bottom: '-200px',
//         left: '-100px',
//         width: '50%',
//         height: '40%',
//         transform: 'rotate(70deg)',
//     },

//     // For Fifth Page =>
//     fifthPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundColor: '#efe6dc',
//     },
//     fifthPageRightBackground: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         width: '45%',
//         height: '70%',
//         backgroundColor: '#728478',
//     },
//     fifthPageImageContainer: {
//         position: 'relative',
//         left: 0,
//         top: '50%',
//         width: '90%',
//         height: '40%',
//         border: '10px solid #efe6dc'
//     },
//     fifthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     fifthPageProductPriceContainer: {
//         position: 'absolute',
//         top: '10%',
//         right: '25%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     fifthPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     fifthPageContentContainer: {
//         position: 'absolute',
//         top: '10%',
//         left: '10%',
//         width: '40%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     fifthPageProductName: {
//         fontSize: 25,
//     },
//     fifthPageProdutDescription: {
//         fontSize: 15,
//     },
//     fifthPageTopRoundOne: {
//         position: 'absolute',
//         top: '-400px',
//         right: '-750px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     fifthPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-450px',
//         right: '-650px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     fifthPageTopShapeContainer: {
//         position: 'absolute',
//         top: '-150px',
//         right: '-120px',
//         width: '50%',
//         height: '40%',
//         transform: 'rotate(120deg)',
//     },

//     // For sixth Page =>
//     sixthPageTopBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '50%',
//         backgroundColor: '#dfcdc1',
//     },
//     sixthPageBottomBackground: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         width: '100%',
//         height: '50%',
//         backgroundColor: '#eae7dc',
//     },
//     sixthPageImageContainer: {
//         position: 'relative',
//         left: '10%',
//         top: '10%',
//         width: '50%',
//         height: '70%',
//         border: '10px solid #efe6dc'
//     },
//     sixthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     sixthPageProductPriceContainer: {
//         position: 'absolute',
//         left: '45%',
//         top: '50%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     sixthPageProductNameContainer: {
//         position: 'absolute',
//         left: '45%',
//         top: '60%',
//         backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px',
//         width: '50%',
//     },
//     sixthPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     sixthPageProdutDescriptionContainer: {
//         position: 'absolute',
//         top: '20%',
//         left: '65%',
//         width: '30%',
//         // height: '10%',
//         display: 'flex',
//         justifyContent: 'center',

//     },
//     sixthPageProductName: {
//         fontSize: 25,
//     },
//     sixthPageProdutDescription: {
//         fontSize: 15,
//     },
//     sixthPageTopRoundOne: {
//         position: 'absolute',
//         top: '-400px',
//         right: '-750px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     sixthPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-450px',
//         right: '-650px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     sixthPageBottomRoundOne: {
//         position: 'absolute',
//         bottom: '-150px',
//         left: '-300px',
//         width: '600px',
//         height: '600px',
//         borderRadius: '100%',
//         border: '2px solid #728478',
//     },

//     sixthPageBottomRoundTwo: {
//         position: 'absolute',
//         bottom: '0px',
//         left: '-350px',
//         width: '500px',
//         height: '500px',
//         borderRadius: '100%',
//         border: '5px solid #728478',
//     },
//     sixthPageBottomShapeContainer: {
//         position: 'absolute',
//         bottom: '5%',
//         left: '5%',
//         width: '80%',
//         height: '30%',
//         // transform: 'rotate(80deg)',
//     },

//     // For seventh Page =>
//     seventhPageLeftUpperBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '65%',
//         height: '20%',
//         backgroundColor: '#dfcdc1',
//     },
//     seventhPageLeftBottomBackground: {
//         position: 'absolute',
//         top: '20%',
//         left: 0,
//         width: '65%',
//         height: '80%',
//         backgroundColor: '#efe6dc',
//     },
//     seventhPageRightBackground: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         width: '45%',
//         height: '100%',
//         backgroundColor: '#728478',
//     },
//     seventhPageImageContainer: {
//         position: 'relative',
//         left: '-10px',
//         top: '10%',
//         width: '80%',
//         height: '40%',
//         border: '10px solid #efe6dc'
//     },
//     seventhPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     seventhPageProductPriceContainer: {
//         position: 'absolute',
//         top: '70%',
//         right: '10%',
//         // backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     seventhPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     seventhPageContentContainer: {
//         position: 'absolute',
//         top: '55%',
//         left: '5%',
//         width: '45%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         backgroundColor: '#5b5f62',
//         color: '#eeefea',
//         padding: '20px'
//     },
//     seventhPageProductName: {
//         fontSize: 25,
//     },
//     seventhPageProdutDescription: {
//         fontSize: 15,
//     },
//     seventhPageTopRoundOne: {
//         position: 'absolute',
//         top: '-400px',
//         right: '-750px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #5b5f62'
//     },
//     seventhPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-450px',
//         right: '-650px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #5b5f62'
//     },
//     seventhPageTopShapeContainer: {
//         position: 'absolute',
//         top: '0%',
//         right: '-180px',
//         width: '50%',
//         height: '40%',
//         transform: 'rotate(80deg)',
//     },

//     // For eight Page =>
//     eightPageleftBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '70%',
//         height: '100%',
//         backgroundColor: '#f5efe3',
//     },
//     eightPageRightBackground: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         width: '30%',
//         height: '100%',
//         backgroundColor: '#5b5f62',
//     },

//     eightPageImageContainer: {
//         position: 'relative',
//         left: '10%',
//         top: '10%',
//         width: '50%',
//         height: '50%',
//         border: '10px solid white'
//     },
//     eightPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     eightPageProductPriceContainer: {
//         position: 'absolute',
//         top: '70%',
//         right: '10%',
//         // backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     eightPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     eightPageContentContainer: {
//         position: 'absolute',
//         top: '65%',
//         right: 0,
//         width: '80%',
//         height: '25%',
//         display: 'flex',
//         justifyContent: 'space-between',
//         backgroundColor: '#728478',
//         color: '#eeefea',
//         padding: '20px 200px 20px 20px'
//     },
//     eightPageProductName: {
//         fontSize: 25,
//     },
//     eightPageProdutDescription: {
//         fontSize: 15,
//     },
//     eightPageTopRoundOne: {
//         position: 'absolute',
//         top: '-400px',
//         right: '-750px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #e7d3c5'
//     },
//     eightPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-450px',
//         right: '-650px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #e7d3c5'
//     },
//     eightPageTopShapeContainer: {
//         position: 'absolute',
//         top: '-140px',
//         right: '-100px',
//         width: '70%',
//         height: '25%',
//         transform: 'rotate(180deg)',
//     },

//     // For ninth Page =>
//     ninthPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         backgroundColor: '#5b5f62',
//     },

//     ninthPageImageContainer: {
//         position: 'relative',
//         left: '10%',
//         top: '10%',
//         width: '80%',
//         height: '80%',
//         border: '10px solid white'
//     },
//     ninthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     ninthPageProductPriceContainer: {
//         position: 'absolute',
//         top: '70%',
//         right: '10%',
//         // backgroundColor: '#323230',
//         color: '#eeefea',
//         padding: '10px'
//     },
//     ninthPageProductPrice: {
//         fontSize: 25,
//         fontWeight: 'bold'
//     },
//     ninthPageContentContainer: {
//         position: 'absolute',
//         top: '55%',
//         left: 0,
//         width: '60%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'space-between',
//         backgroundColor: '#728478',
//         color: '#eeefea',
//         padding: '20px 20px 20px 60px'
//     },
//     ninthPageProductName: {
//         fontSize: 25,
//     },
//     ninthPageProdutDescription: {
//         fontSize: 15,
//     },
//     ninthPageTopRoundOne: {
//         position: 'absolute',
//         top: '-600px',
//         left: '-130px',
//         width: '900px',
//         height: '1000px',
//         borderRadius: '100%',
//         border: '5px solid #efe6dc'
//     },
//     ninthPageTopRoundTwo: {
//         position: 'absolute',
//         top: '-650px',
//         left: '-250px',
//         width: '900px',
//         height: '950px',
//         borderRadius: '100%',
//         border: '2px solid #efe6dc'
//     },
//     ninthPageBottomShapeContainer: {
//         position: 'absolute',
//         bottom: '-100px',
//         right: '-100px',
//         width: '70%',
//         height: '25%',
//         transform: 'rotate(180deg)',
//     },

//     // Last Page Style =>

//     lastPageTopBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '50%',
//         backgroundColor: '#efe6dc',
//     },

//     lastPageBackground: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         // backgroundColor: '#f8d4c1',
//         backgroundColor: '#c4ad95',
//         width: '100%',
//         height: '50%',
//     },

//     lastPageLogoImageContainer: {
//         position: 'relative',
//         top: '-20%',
//         width: '40%',
//         height: 'auto',
//         margin: 'auto',
//     },

//     lastPageContentContainer: {
//         position: 'absolute',
//         bottom: 0,
//         left: '20%',
//         width: '60%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         flexWrap: 'wrap',
//         textAlign: 'center',
//         gap: 15,
//     },
//     lastPageManagerDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         width: '100%',
//         fontSize: 15,

//     },
//     lastPageManagerNameContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'center',
//         gap: '30px'
//     },
//     lastPageManagerNumberContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'center',
//         gap: '30px'
//     },
//     lastPageStoreDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 10,
//         fontSize: 15,
//     },
//     lastpageCopyright: {
//         margin: 'auto',
//         fontSize: 10,
//     },
//     socialLinks: {
//         flexDirection: 'row',
//         justifyContent: 'center',
//         gap: 10,
//         marginTop: 80,

//     },
//     icon: {
//         width: 24,
//         height: 24,
//     },
// });

// function TailoredTrends({ jsonData, vendor }) {
//     const [Data, setData] = useState();

//     useEffect(() => {
//         setData(jsonData);
//     }, [jsonData]);

//     console.log("This is the data of TailoredTrends :=>", Data);
//     console.log("IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", Data?.Product?.[0]?.image)
//     return (
//         <Document>
//             <Page size="A4" style={styles.page}>
//                 <View style={styles.firstPageBackground} />
//                 <View style={styles.firstPageBottomRightContainer} />
//                 <View style={styles.firstPageBottomShapeContainer} >
//                     <Image
//                         style={styles.firstPageBottomShape}
//                         src="/image/shape1.png"
//                     />
//                 </View>
//                 <View style={styles.firstPageUpperLeftContainer} >
//                     <View style={styles.firstPageMainImageContainer}>
//                         <Image
//                             style={styles.firstPageMainImage}
//                             src="/image/frontPageImage.jpg"
//                         />
//                     </View>
//                 </View>
//                 <View style={styles.logoImageContainer}>
//                     <Image
//                         style={styles.logoImage}
//                         src="/logo.png"
//                     />
//                 </View>
//                 <View style={[styles.greetingContainer]} >
//                     <Text style={styles.greeting}>Hello, </Text>
//                 </View>
//                 <View style={[styles.loyaltyContainer]} >
//                     <Image
//                         style={styles.loyaltyPointsImage}
//                         src="/loyaltyPointsWhite.png"
//                     />
//                     <Text style={styles.loyaltyPoints}>25 loyaltyPoints </Text>
//                 </View>
//                 <View style={[styles.customerNameContainer]} >
//                     <Text style={styles.customerName}>{Data?.Customer?.customerName}</Text>
//                 </View>
//                 <View style={[styles.customerMessageContainer]} >
//                     <Text style={styles.customerMessage}>Based on your interests and recent activities, we’ve carefully curated a range of items that we believe you’ll love. Whether you’re looking for something specific or just browsing, we hope you find inspiration within these pages.</Text>
//                 </View>
//                 <View style={styles.firstPageTopRoundOne} />
//                 <View style={styles.firstPageTopRoundTwo} />
//                 <View style={styles.firstPageTopRoundThree} />
//                 <View style={styles.firstPageBottomRoundOne} />
//                 <View style={styles.firstPageBottomRoundTwo} />
//             </Page>

//             {/* Second Page */}
//             {Data?.Product?.length > 0 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.secondPageBackground} />
//                     <View style={styles.secondPageTopContainer} />
//                     <View style={styles.secondPageBottomRoundOne} />
//                     <View style={styles.secondPageBottomRoundTwo} />
//                     <View style={styles.secondPageTopUpperContainer} />
//                     <View style={styles.secondPageImageContainer}>
//                         <Image
//                             style={styles.secondPageImage}
//                             src={
//                                 Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                                     ? Data?.Product?.[0]?.image
//                                     : Data?.Product?.[0]?.productImage // Fallback to productImage
//                             } />
//                     </View>
//                     <View style={styles.secondPageProductPriceContainer}>
//                         <Text style={styles.secondPageProductPrice}>{Data?.Product?.[0]?.price}</Text>
//                     </View>
//                     <View style={styles.secondPageBottomContentContainer}>
//                         <Text style={styles.secondPageProductName}>{Data?.Product?.[0]?.title}</Text>
//                         <Text style={styles.secondPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>
//                     </View>
//                 </Page>
//             )}

//             {/* Third Page */}
//             {Data?.Product?.length > 1 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.thirdPageLeftBackground} />
//                     <View style={styles.thirdPageRightBackground} />

//                     <View style={styles.thirdPageBottomRoundOne} />
//                     <View style={styles.thirdPageBottomRoundTwo} />
//                     <View style={styles.thirdPageBottomShapeContainer} >
//                         <Image
//                             style={styles.thirdPageBottomShape}
//                             src="/image/shape2.png"
//                         />
//                     </View>
//                     <View style={styles.thirdPageImageContainer}>
//                         <Image
//                             style={styles.thirdPageImage}
//                             src={
//                                 Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                                     ? Data?.Product?.[1]?.image
//                                     : Data?.Product?.[1]?.productImage // Fallback to productImage
//                             } />
//                     </View>
//                     <View style={styles.thirdPageProductPriceContainer}>
//                         <Text style={styles.thirdPageProductPrice}>{Data?.Product?.[1]?.price}</Text>
//                     </View>
//                     <View style={styles.thirdPageBottomContentContainer}>
//                         <Text style={styles.thirdPageProductName}>{Data?.Product?.[1]?.title}</Text>
//                         <Text style={styles.thirdPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>

//                     </View>
//                 </Page>
//             )}
//             {/* Fourth Page */}
//             {Data?.Product?.length > 2 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.fourthPageTopBackground} />
//                     <View style={styles.fourthPageBottomBackground} />

//                     <View style={styles.fourthPageBottomRoundOne} />
//                     <View style={styles.fourthPageBottomRoundTwo} />
//                     <View style={styles.fourthPageBottomShapeContainer} >
//                         <Image
//                             style={styles.fourthPageBottomShape}
//                             src="/image/shape2.png"
//                         />
//                     </View>
//                     <View style={styles.fourthPageImageContainer}>
//                         <Image
//                             style={styles.fourthPageImage}
//                             src={
//                                 Data?.Product?.[2]?.image && Data?.Product?.[2]?.image !== "N/A"
//                                     ? Data?.Product?.[2]?.image
//                                     : Data?.Product?.[2]?.productImage // Fallback to productImage
//                             } />
//                     </View>
//                     <View style={styles.fourthPageTopRoundOne} />
//                     <View style={styles.fourthPageTopRoundTwo} />
//                     <View style={styles.fourthPageProductPriceContainer}>
//                         <Text style={styles.fourthPageProductPrice}>{Data?.Product?.[2]?.price}</Text>
//                     </View>

//                     <View style={styles.fourthPageProductNameContainer}>
//                         <Text style={styles.fourthPageProductName}>{Data?.Product?.[2]?.title}</Text>
//                     </View>
//                     <View style={styles.fourthPageProdutDescriptionContainer}>
//                         <Text style={styles.fourthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>

//                     </View>
//                 </Page>
//             )}

//             {/* Fifth Page */}
//             {Data?.Product?.length > 3 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.fifthPageBackground} />
//                     <View style={styles.fifthPageRightBackground} />

//                     <View style={styles.fifthPageTopRoundOne} />
//                     <View style={styles.fifthPageTopRoundTwo} />
//                     <View style={styles.fifthPageTopShapeContainer} >
//                         <Image
//                             style={styles.fifthPageTopShape}
//                             src="/image/shape1.png"
//                         />
//                     </View>
//                     <View style={styles.fifthPageImageContainer}>
//                         <Image
//                             style={styles.fifthPageImage}
//                             src={
//                                 Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                                     ? Data?.Product?.[3]?.image
//                                     : Data?.Product?.[3]?.productImage // Fallback to productImage
//                             }
//                         />
//                     </View>
//                     <View style={styles.fifthPageProductPriceContainer}>
//                         <Text style={styles.fifthPageProductPrice}>{Data?.Product?.[3]?.price}</Text>
//                     </View>
//                     <View style={styles.fifthPageContentContainer}>
//                         <Text style={styles.fifthPageProductName}>{Data?.Product?.[3]?.title}</Text>
//                         <Text style={styles.fifthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>

//                     </View>
//                 </Page>
//             )}
//             {/* Sixth Page */}
//             {Data?.Product?.length > 4 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.sixthPageTopBackground} />
//                     <View style={styles.sixthPageBottomBackground} />

//                     <View style={styles.sixthPageBottomShapeContainer} >
//                         <Image
//                             style={styles.sixthPageBottomShape}
//                             src="/image/shape2.png"
//                         />
//                     </View>
//                     <View style={styles.sixthPageImageContainer}>
//                         <Image
//                             style={styles.sixthPageImage}
//                             src={
//                                 Data?.Product?.[4]?.image && Data?.Product?.[4]?.image !== "N/A"
//                                     ? Data?.Product?.[4]?.image
//                                     : Data?.Product?.[4]?.productImage // Fallback to productImage
//                             } />
//                     </View>
//                     <View style={styles.sixthPageBottomRoundOne} />
//                     <View style={styles.sixthPageBottomRoundTwo} />
//                     <View style={styles.sixthPageTopRoundOne} />
//                     <View style={styles.sixthPageTopRoundTwo} />
//                     <View style={styles.sixthPageProductPriceContainer}>
//                         <Text style={styles.sixthPageProductPrice}>{Data?.Product?.[4]?.price}</Text>
//                     </View>

//                     <View style={styles.sixthPageProductNameContainer}>
//                         <Text style={styles.sixthPageProductName}>{Data?.Product?.[4]?.title}</Text>
//                     </View>
//                     <View style={styles.sixthPageProdutDescriptionContainer}>
//                         <Text style={styles.sixthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>

//                     </View>
//                 </Page>
//             )}
//             {/* Seventh Page */}
//             {Data?.Product?.length > 5 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.seventhPageLeftUpperBackground} />
//                     <View style={styles.seventhPageLeftBottomBackground} />
//                     <View style={styles.seventhPageRightBackground} />

//                     <View style={styles.seventhPageTopShapeContainer} >
//                         <Image
//                             style={styles.seventhPageTopShape}
//                             src="/image/shape1.png"
//                         />
//                     </View>
//                     <View style={styles.seventhPageImageContainer}>
//                         <Image
//                             style={styles.seventhPageImage}
//                             src={
//                                 Data?.Product?.[5]?.image && Data?.Product?.[5]?.image !== "N/A"
//                                     ? Data?.Product?.[5]?.image
//                                     : Data?.Product?.[5]?.productImage // Fallback to productImage
//                             } />
//                     </View>
//                     <View style={styles.seventhPageTopRoundOne} />
//                     <View style={styles.seventhPageTopRoundTwo} />
//                     <View style={styles.seventhPageProductPriceContainer}>
//                         <Text style={styles.seventhPageProductPrice}>{Data?.Product?.[5]?.price}</Text>
//                     </View>
//                     <View style={styles.seventhPageContentContainer}>
//                         <Text style={styles.seventhPageProductName}>{Data?.Product?.[5]?.title}</Text>
//                         <Text style={styles.seventhPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* eight Page */}
//             {Data?.Product?.length > 6 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.eightPageLeftBackground} />
//                     <View style={styles.eightPageRightBackground} />
//                     <View style={styles.eightPageTopShapeContainer} >
//                         <Image
//                             style={styles.eightPageTopShape}
//                             src="/image/shape1.png"
//                         />
//                     </View>
//                     <View style={styles.eightPageImageContainer}>
//                         <Image
//                             style={styles.eightPageImage}
//                             src={
//                                 Data?.Product?.[6]?.image && Data?.Product?.[6]?.image !== "N/A"
//                                     ? Data?.Product?.[6]?.image
//                                     : Data?.Product?.[6]?.productImage // Fallback to productImage
//                             }
//                         />
//                     </View>
//                     <View style={styles.eightPageTopRoundOne} />
//                     <View style={styles.eightPageTopRoundTwo} />

//                     <View style={styles.eightPageContentContainer}>
//                         <Text style={styles.eightPageProductName}>{Data?.Product?.[6]?.title}</Text>
//                         <Text style={styles.eightPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>
//                         <Text style={styles.eightPageProductPrice}>{Data?.Product?.[6]?.price}</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* ninth Page */}
//             {Data?.Product?.length > 7 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.ninthPageBackground} />
//                     <View style={styles.ninthPageTopRoundOne} />
//                     <View style={styles.ninthPageTopRoundTwo} />
//                     <View style={styles.ninthPageBottomShapeContainer} >
//                         <Image
//                             style={styles.ninthPageTopShape}
//                             src="/image/shape1.png"
//                         />
//                     </View>
//                     <View style={styles.ninthPageImageContainer}>
//                         <Image
//                             style={styles.ninthPageImage}
//                             src={
//                                 Data?.Product?.[7]?.image && Data?.Product?.[7]?.image !== "N/A"
//                                     ? Data?.Product?.[7]?.image
//                                     : Data?.Product?.[7]?.productImage // Fallback to productImage
//                             } />
//                     </View>

//                     <View style={styles.ninthPageContentContainer}>
//                         <Text style={styles.ninthPageProductName}>{Data?.Product?.[7]?.title}</Text>
//                         <Text style={styles.ninthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products.</Text>
//                         <Text style={styles.ninthPageProductPrice}>{Data?.Product?.[7]?.price}</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* Last Page */}
//             <Page size="A4" style={styles.page}>
//                           {/* <View style={styles.lastPageBackground} /> */}
//                           {/* <View style={styles.lastPageUpperContainer}> */}
//                               {/* <View style={styles.lastPageContentContainer}> */}
//                                   <View style={styles.lastPageLogoImageContainer}>
//                                       <Image
//                                           style={styles.lastPageLogoImage}
//                                           // src={(vendor?.vendorDetails?.logo?.url) ? vendor?.vendorDetails?.logo?.url : "/logo.png"}
//                                           // src="https://storage.googleapis.com/fixlabsinficonnect/documents/20241206T122850788Z-1d8e1c615e90f989f299e273e3b7bcaa%20(1).png"
//                                           src="/logo.png"
//                                       />
//                                   </View>

//                                   {/* <View style={styles.lastPageManagerDetailsContainer}>
//                                       <View style={styles.lastPageManagerNameAndNumberContainer}>
//                                           <Text style={styles.lastPageManagerName}>{Data?.Store?.managername}</Text>
//                                           <Text style={styles.lastPageManagerPhoneNumber}>{Data?.Store?.storePhone}</Text>
//                                       </View>
//                                       <View style={styles.lastPageManagerEmailContainer}>
//                                           <Text style={styles.lastPageManagerName}>Pranjal.Sengar@gmail.com</Text>
//                                       </View>
//                                   </View> */}
//                                   {/* <View style={styles.lastPageStoreDetailsContainer}> */}

//                                       {/* <View style={styles.storeLocationContainer}>
//                                           <Text style={styles.storeLocation}>{Data?.Store?.storeAddress}</Text>
//                                       </View> */}

//                                       {/* <View style={styles.socialLinks}>
//                                           <Link src="https://www.facebook.com/login.php" style={styles.iconLink}>
//                                               <Image
//                                                   src="/images/facebookLogoBlue.png"
//                                                   style={styles.icon}
//                                                   alt="Facebook"
//                                               />
//                                           </Link>
//                                           <Link src="https://www.instagram.com/accounts/login/" style={styles.iconLink}>
//                                               <Image
//                                                   src="/images/instagramLogoBlue.png"
//                                                   style={styles.icon}
//                                                   alt="Instagram"
//                                               />
//                                           </Link>
//                                           <Link src="https://x.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJteCI6IjIifQ%3D%3D%22%7D" style={styles.iconLink}>
//                                               <Image
//                                                   src="/images/twitterLogoBlue.png"
//                                                   style={styles.icon}
//                                                   alt="Twitter"
//                                               />
//                                           </Link>
//                                           <Link src="https://discord.com/login" style={styles.iconLink}>
//                                               <Image
//                                                   src="/images/discordLogoBlue.png"
//                                                   style={styles.icon}
//                                                   alt="Discord"
//                                               />
//                                           </Link>
//                                       </View> */}

//                                       {/* <View style={styles.storeCopyrightContainer}>
//                                           <Text style={styles.lastpageCopyright}> */}
//                                               {/* © {new Date().getFullYear()} {vendor?.vendorDetails?.name}™. All Rights Reserved. Built with */}
//                                               {/* © 2021-2022 Fixlabs™. All Rights Reserved. Built with */}
//                                           {/* </Text>
//                                       </View> */}

//                                   {/* </View> */}

//                               {/* </View> */}
//                           {/* </View> */}
//                       </Page>
//         </Document>
//     )
// }

// export default TailoredTrends









// import React, { useEffect, useState } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
//   PDFViewer,
//   Link,
// } from "@react-pdf/renderer";

// // Define styles
// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     position: "relative",
//   },
//   loyaltyContainer: {
//     position: "absolute", // Position the container absolutely
//     right: 0, // Align to the right by 5%
//     top: "45%", // Position from the top by 45%
//     transform: "rotate(-90deg)",
//     display: "flex", // Enable flexbox layout
//     flexDirection: "row", // Arrange content in a row (you can change to 'column' if needed)
//     alignItems: "center", // Center items vertically
//     justifyContent: "center", // Center items horizontally
//   },
//   loyaltyPointsImage: {
//     width: 50, // Set image width
//     height: 50, // Set image height
//     marginRight: 10, // Add spacing between the image and text
//   },
//   loyaltyPoints: {
//     fontSize: 16, // Adjust text size
//     color: "#FFFFFF", // Set text color (black, adjust as needed)
//     fontWeight: "bold", // Make text bold
//   },
//   firstPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "#5b5f62",
//   },
//   firstPageTopRoundOne: {
//     position: "absolute",
//     top: "-200px",
//     left: "-520px",
//     width: "700px",
//     height: "700px",
//     borderRadius: "100%",
//     border: "4px solid #728478",
//   },
//   firstPageTopRoundTwo: {
//     position: "absolute",
//     top: "-300px",
//     left: "-500px",
//     width: "700px",
//     height: "700px",
//     borderRadius: "100%",
//     border: "2.5px solid #728478",
//   },
//   firstPageTopRoundThree: {
//     position: "absolute",
//     top: "-270px",
//     left: "-600px",
//     width: "750px",
//     height: "750px",
//     borderRadius: "100%",
//     // backgroundColor:'blue',
//     border: "2px solid #728478",
//   },
//   firstPageUpperLeftContainer: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "65%",
//     height: "70%",
//     backgroundColor: "#e4d0c5",
//     display: "flex",
//     justifyContent: "flex-end",
//     alignItems: "flex-end",
//   },
//   firstPageMainImageContainer: {
//     height: "85%",
//     width: "85%",
//     border: "10px solid white",
//   },
//   firstPageMainImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   logoImageContainer: {
//     position: "relative",
//     top: "10%",
//     left: "80%",
//     width: "20%",
//     height: "8%",
//     backgroundColor: "#e4d0c5",
//     padding: "2px",
//     display: "flex",
//     justifyContent: "center",
//     alignContent: "center",
//     alignItems: "center",
//   },
//   logoImage: {
//     width: "70%",
//     height: "auto",
//     objectFit: "cover",
//     marginLeft: "15%",
//   },
//   firstPageUpperContainer: {
//     position: "absolute",
//     top: 0,
//     right: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "60%",
//     height: "10%",
//   },
//   firstPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "80%",
//     position: "absolute",
//     top: "10%",
//     left: "10%",
//   },

//   firstPageContentBox: {
//     position: "absolute",
//     bottom: "10%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//     margin: "auto",
//   },
//   greetingContainer: {
//     // position: 'absolute',
//     // left: '40%',
//     // top: '20%',
//     // backgroundColor: '#323230',
//     // color: '#eeefea',
//     // padding: '10px 80px 10px 10px'
//     position: "absolute",
//     left: "50%",
//     top: "20%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px 20px 10px 10px",
//   },

//   greeting: {
//     fontSize: 35,
//     fontWeight: "bold",
//   },
//   customerNameContainer: {
//     position: "absolute",
//     // left: '40%',
//     // left: '40%',
//     left: "50%",
//     top: "28%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px 10px 10px 10px",
//   },
//   customerName: {
//     fontSize: 40,
//     fontWeight: "bold",
//   },
//   customerMessageContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "75%",
//     color: "white",
//     width: "35%",
//     height: "20%",
//   },
//   customerMessage: {
//     fontSize: 15,
//   },
//   firstPageBottomRightContainer: {
//     position: "absolute",
//     bottom: 0,
//     right: 0,
//     backgroundColor: "#728478",
//     width: "50%",
//     height: "35%",
//   },
//   firstPageBottomShapeContainer: {
//     // position: 'absolute',
//     // bottom: '-110px',
//     // right: '-60px',
//     // width: '50%',
//     // height: '40%',
//     position: "absolute",
//     bottom: "-80px",
//     right: "-150px",
//     width: "70%",
//     height: "25%",
//     transform: "rotate(180deg)",
//   },
//   firstPageBottomRoundOne: {
//     position: "absolute",
//     bottom: "-260px",
//     right: "-350px",
//     width: "500px",
//     height: "500px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   firstPageBottomRoundTwo: {
//     position: "absolute",
//     bottom: "-460px",
//     right: "-390px",
//     width: "700px",
//     height: "700px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   // For Second Page =>

//   secondPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "#efe6dc",
//   },
//   secondPageTopContainer: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "80%",
//     height: "60%",
//     backgroundColor: "#728478",
//   },
//   secondPageImageContainer: {
//     position: "relative",
//     left: "10%",
//     top: "10%",
//     width: "60%",
//     height: "60%",
//     border: "10px solid #efe6dc",
//   },
//   secondPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   secondPageProductPriceContainer: {
//     position: "absolute",
//     right: "5%",
//     top: "30%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },

//   secondPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   secondPageBottomContentContainer: {
//     position: "absolute",
//     top: "72%",
//     left: "10%",
//     width: "50%",
//     height: "25%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   secondPageProductName: {
//     fontSize: 25,
//   },
//   secondPageProdutDescription: {
//     fontSize: 15,
//   },
//   secondPageBottomRoundOne: {
//     position: "absolute",
//     top: "-350px",
//     left: "-500px",
//     width: "1100px",
//     height: "1100px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   secondPageBottomRoundTwo: {
//     position: "absolute",
//     top: "-350px",
//     left: "-100px",
//     width: "900px",
//     height: "900px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   secondPageTopUpperContainer: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "50%",
//     height: "30%",
//     backgroundColor: "#5b6066",
//   },

//   // For third Page =>
//   thirdPageLeftBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "40%",
//     height: "100%",
//     backgroundColor: "#efe6dc",
//   },
//   thirdPageRightBackground: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     width: "60%",
//     height: "100%",
//     backgroundColor: "#c4ad95",
//   },
//   thirdPageImageContainer: {
//     position: "relative",
//     left: "50%",
//     top: "10%",
//     width: "40%",
//     height: "50%",
//     border: "10px solid #efe6dc",
//   },
//   thirdPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   thirdPageProductPriceContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "30%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },
//   thirdPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   thirdPageBottomContentContainer: {
//     position: "absolute",
//     top: "65%",
//     left: "10%",
//     width: "60%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   thirdPageProductName: {
//     fontSize: 25,
//   },
//   thirdPageProdutDescription: {
//     fontSize: 15,
//   },
//   thirdPageBottomRoundOne: {
//     position: "absolute",
//     bottom: "-350px",
//     right: "-670px",
//     width: "1100px",
//     height: "1100px",
//     borderRadius: "100%",
//     border: "2px solid #728478",
//   },
//   thirdPageBottomRoundTwo: {
//     position: "absolute",
//     bottom: "-400px",
//     right: "-2000px",
//     width: "2200px",
//     height: "2200px",
//     borderRadius: "100%",
//     border: "5px solid #728478",
//   },
//   thirdPageBottomShapeContainer: {
//     position: "absolute",
//     bottom: "-250px",
//     left: "25%",
//     width: "50%",
//     height: "40%",
//     transform: "rotate(70deg)",
//   },

//   // For fourth Page =>
//   fourthPageTopBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#efe6dc",
//   },
//   fourthPageBottomBackground: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#c4ad95",
//   },
//   fourthPageImageContainer: {
//     position: "relative",
//     left: "10%",
//     top: "10%",
//     width: "92%",
//     height: "50%",
//     border: "10px solid #efe6dc",
//   },
//   fourthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fourthPageProductPriceContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "20%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },
//   fourthPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "30%",
//     width: "80%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },
//   fourthPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   fourthPageProdutDescriptionContainer: {
//     position: "absolute",
//     top: "65%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//   },
//   fourthPageProductName: {
//     fontSize: 25,
//   },
//   fourthPageProdutDescription: {
//     fontSize: 15,
//   },
//   fourthPageTopRoundOne: {
//     position: "absolute",
//     top: "-400px",
//     right: "-750px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   fourthPageTopRoundTwo: {
//     position: "absolute",
//     top: "-450px",
//     right: "-650px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   fourthPageBottomRoundOne: {
//     position: "absolute",
//     bottom: "-350px",
//     left: "-670px",
//     width: "1100px",
//     height: "1100px",
//     borderRadius: "100%",
//     border: "2px solid #728478",
//   },
//   fourthPageBottomRoundTwo: {
//     position: "absolute",
//     bottom: "-300px",
//     left: "-250px",
//     width: "700px",
//     height: "600px",
//     borderRadius: "100%",
//     border: "5px solid #728478",
//   },
//   fourthPageBottomShapeContainer: {
//     position: "absolute",
//     bottom: "-200px",
//     left: "-100px",
//     width: "50%",
//     height: "40%",
//     transform: "rotate(70deg)",
//   },

//   // For Fifth Page =>
//   fifthPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "#efe6dc",
//   },
//   fifthPageRightBackground: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     width: "45%",
//     height: "70%",
//     backgroundColor: "#728478",
//   },
//   fifthPageImageContainer: {
//     position: "relative",
//     left: 0,
//     top: "50%",
//     width: "90%",
//     height: "40%",
//     border: "10px solid #efe6dc",
//   },
//   fifthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fifthPageProductPriceContainer: {
//     position: "absolute",
//     top: "10%",
//     right: "25%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },
//   fifthPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   fifthPageContentContainer: {
//     position: "absolute",
//     top: "10%",
//     left: "10%",
//     width: "40%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   fifthPageProductName: {
//     fontSize: 25,
//   },
//   fifthPageProdutDescription: {
//     fontSize: 15,
//   },
//   fifthPageTopRoundOne: {
//     position: "absolute",
//     top: "-400px",
//     right: "-750px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   fifthPageTopRoundTwo: {
//     position: "absolute",
//     top: "-450px",
//     right: "-650px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   fifthPageTopShapeContainer: {
//     position: "absolute",
//     top: "-150px",
//     right: "-120px",
//     width: "50%",
//     height: "40%",
//     transform: "rotate(120deg)",
//   },

//   // For sixth Page =>
//   sixthPageTopBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#dfcdc1",
//   },
//   sixthPageBottomBackground: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#eae7dc",
//   },
//   sixthPageImageContainer: {
//     position: "relative",
//     left: "10%",
//     top: "10%",
//     width: "50%",
//     height: "70%",
//     border: "10px solid #efe6dc",
//   },
//   sixthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   sixthPageProductPriceContainer: {
//     position: "absolute",
//     left: "45%",
//     top: "50%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//   },
//   sixthPageProductNameContainer: {
//     position: "absolute",
//     left: "45%",
//     top: "60%",
//     backgroundColor: "#323230",
//     color: "#eeefea",
//     padding: "10px",
//     width: "50%",
//   },
//   sixthPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   sixthPageProdutDescriptionContainer: {
//     position: "absolute",
//     top: "20%",
//     left: "65%",
//     width: "30%",
//     // height: '10%',
//     display: "flex",
//     justifyContent: "center",
//   },
//   sixthPageProductName: {
//     fontSize: 25,
//   },
//   sixthPageProdutDescription: {
//     fontSize: 15,
//   },
//   sixthPageTopRoundOne: {
//     position: "absolute",
//     top: "-400px",
//     right: "-750px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   sixthPageTopRoundTwo: {
//     position: "absolute",
//     top: "-450px",
//     right: "-650px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   sixthPageBottomRoundOne: {
//     position: "absolute",
//     bottom: "-150px",
//     left: "-300px",
//     width: "600px",
//     height: "600px",
//     borderRadius: "100%",
//     border: "2px solid #728478",
//   },

//   sixthPageBottomRoundTwo: {
//     position: "absolute",
//     bottom: "0px",
//     left: "-350px",
//     width: "500px",
//     height: "500px",
//     borderRadius: "100%",
//     border: "5px solid #728478",
//   },
//   sixthPageBottomShapeContainer: {
//     position: "absolute",
//     bottom: "5%",
//     left: "5%",
//     width: "80%",
//     height: "30%",
//     // transform: 'rotate(80deg)',
//   },

//   // For seventh Page =>
//   seventhPageLeftUpperBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "65%",
//     height: "20%",
//     backgroundColor: "#dfcdc1",
//   },
//   seventhPageLeftBottomBackground: {
//     position: "absolute",
//     top: "20%",
//     left: 0,
//     width: "65%",
//     height: "80%",
//     backgroundColor: "#efe6dc",
//   },
//   seventhPageRightBackground: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     width: "45%",
//     height: "100%",
//     backgroundColor: "#728478",
//   },
//   seventhPageImageContainer: {
//     position: "relative",
//     left: "-10px",
//     top: "10%",
//     width: "80%",
//     height: "40%",
//     border: "10px solid #efe6dc",
//   },
//   seventhPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   seventhPageProductPriceContainer: {
//     position: "absolute",
//     top: "70%",
//     right: "10%",
//     // backgroundColor: '#323230',
//     color: "#eeefea",
//     padding: "10px",
//   },
//   seventhPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   seventhPageContentContainer: {
//     position: "absolute",
//     top: "55%",
//     left: "5%",
//     width: "45%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//     backgroundColor: "#5b5f62",
//     color: "#eeefea",
//     padding: "20px",
//   },
//   seventhPageProductName: {
//     fontSize: 25,
//   },
//   seventhPageProdutDescription: {
//     fontSize: 15,
//   },
//   seventhPageTopRoundOne: {
//     position: "absolute",
//     top: "-400px",
//     right: "-750px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #5b5f62",
//   },
//   seventhPageTopRoundTwo: {
//     position: "absolute",
//     top: "-450px",
//     right: "-650px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #5b5f62",
//   },
//   seventhPageTopShapeContainer: {
//     position: "absolute",
//     top: "0%",
//     right: "-180px",
//     width: "50%",
//     height: "40%",
//     transform: "rotate(80deg)",
//   },

//   // For eight Page =>
//   eightPageleftBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "70%",
//     height: "100%",
//     backgroundColor: "#f5efe3",
//   },
//   eightPageRightBackground: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     width: "30%",
//     height: "100%",
//     backgroundColor: "#5b5f62",
//   },

//   eightPageImageContainer: {
//     position: "relative",
//     left: "10%",
//     top: "10%",
//     width: "50%",
//     height: "50%",
//     border: "10px solid white",
//   },
//   eightPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   eightPageProductPriceContainer: {
//     position: "absolute",
//     top: "70%",
//     right: "10%",
//     // backgroundColor: '#323230',
//     color: "#eeefea",
//     padding: "10px",
//   },
//   eightPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   eightPageContentContainer: {
//     position: "absolute",
//     top: "65%",
//     right: 0,
//     width: "80%",
//     height: "25%",
//     display: "flex",
//     justifyContent: "space-between",
//     backgroundColor: "#728478",
//     color: "#eeefea",
//     padding: "20px 200px 20px 20px",
//   },
//   eightPageProductName: {
//     fontSize: 25,
//   },
//   eightPageProdutDescription: {
//     fontSize: 15,
//   },
//   eightPageTopRoundOne: {
//     position: "absolute",
//     top: "-400px",
//     right: "-750px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #e7d3c5",
//   },
//   eightPageTopRoundTwo: {
//     position: "absolute",
//     top: "-450px",
//     right: "-650px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #e7d3c5",
//   },
//   eightPageTopShapeContainer: {
//     position: "absolute",
//     top: "-140px",
//     right: "-100px",
//     width: "70%",
//     height: "25%",
//     transform: "rotate(180deg)",
//   },

//   // For ninth Page =>
//   ninthPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "#5b5f62",
//   },

//   ninthPageImageContainer: {
//     position: "relative",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//     height: "80%",
//     border: "10px solid white",
//   },
//   ninthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   ninthPageProductPriceContainer: {
//     position: "absolute",
//     top: "70%",
//     right: "10%",
//     // backgroundColor: '#323230',
//     color: "#eeefea",
//     padding: "10px",
//   },
//   ninthPageProductPrice: {
//     fontSize: 25,
//     fontWeight: "bold",
//   },
//   ninthPageContentContainer: {
//     position: "absolute",
//     top: "55%",
//     left: 0,
//     width: "60%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-between",
//     backgroundColor: "#728478",
//     color: "#eeefea",
//     padding: "20px 20px 20px 60px",
//   },
//   ninthPageProductName: {
//     fontSize: 25,
//   },
//   ninthPageProdutDescription: {
//     fontSize: 15,
//   },
//   ninthPageTopRoundOne: {
//     position: "absolute",
//     top: "-600px",
//     left: "-130px",
//     width: "900px",
//     height: "1000px",
//     borderRadius: "100%",
//     border: "5px solid #efe6dc",
//   },
//   ninthPageTopRoundTwo: {
//     position: "absolute",
//     top: "-650px",
//     left: "-250px",
//     width: "900px",
//     height: "950px",
//     borderRadius: "100%",
//     border: "2px solid #efe6dc",
//   },
//   ninthPageBottomShapeContainer: {
//     position: "absolute",
//     bottom: "-100px",
//     right: "-100px",
//     width: "70%",
//     height: "25%",
//     transform: "rotate(180deg)",
//   },
//   lastPageTopBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#efe6dc",
//   },

//   lastPageBackground: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     backgroundColor: "#c4ad95",
//   },

//   lastPageContentContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "50%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     gap: 15,
//   },

//   lastPageLogoImageContainer: {
//     width: 100,
//     height: "auto",
//     marginBottom: 10,
//   },

//   lastPageLogoImage: {
//     width: "100%",
//     height: "auto",
//   },

//   lastPageManagerDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     width: "100%",
//     fontSize: 14,
//     gap: 5,
//   },

//   lastPageManagerNameContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: 30,
//   },

//   lastPageManagerNumberContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: 30,
//   },

//   lastPageStoreDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: 10,
//     fontSize: 14,
//     marginTop: 10,
//   },

//   lastpageCopyright: {
//     marginTop: 20,
//     fontSize: 10,
//     textAlign: "center",
//   },

//   socialLinks: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     gap: 10,
//     marginTop: 40,
//   },

//   icon: {
//     width: 24,
//     height: 24,
//   },
// });

// function TailoredTrends({ jsonData, vendor }) {
//   const [Data, setData] = useState();

//   useEffect(() => {
//     setData(jsonData);
//   }, [jsonData]);

//   console.log("This is the data of TailoredTrends :=>", Data);
//   console.log(
//     "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
//     Data?.Product?.[0]?.image
//   );
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <View style={styles.firstPageBackground} />
//         <View style={styles.firstPageBottomRightContainer} />
//         <View style={styles.firstPageBottomShapeContainer}>
//           <Image style={styles.firstPageBottomShape} src="/image/shape1.png" />
//         </View>
//         <View style={styles.firstPageUpperLeftContainer}>
//           <View style={styles.firstPageMainImageContainer}>
//             <Image
//               style={styles.firstPageMainImage}
//               src="/image/frontPageImage.jpg"
//             />
//           </View>
//         </View>
//         <View style={styles.logoImageContainer}>
//           <Image style={styles.logoImage} src="/blackberrysLogo.png" />
//         </View>
//         <View style={[styles.greetingContainer]}>
//           <Text style={styles.greeting}>Hello, </Text>
//         </View>
//         <View style={[styles.loyaltyContainer]}>
//           <Image
//             style={styles.loyaltyPointsImage}
//             src="/loyaltyPointsWhite.png"
//           />
//           <Text style={styles.loyaltyPoints}>25 loyaltyPoints </Text>
//         </View>
//         <View style={[styles.customerNameContainer]}>
//           <Text style={styles.customerName}>
//             {Data?.Customer?.customerName}
//           </Text>
//         </View>
//         <View style={[styles.customerMessageContainer]}>
//           <Text style={styles.customerMessage}>
//             Based on your interests and recent activities, we’ve carefully
//             curated a range of items that we believe you’ll love. Whether you’re
//             looking for something specific or just browsing, we hope you find
//             inspiration within these pages.
//           </Text>
//         </View>
//         <View style={styles.firstPageTopRoundOne} />
//         <View style={styles.firstPageTopRoundTwo} />
//         <View style={styles.firstPageTopRoundThree} />
//         <View style={styles.firstPageBottomRoundOne} />
//         <View style={styles.firstPageBottomRoundTwo} />
//       </Page>

//       {/* Second Page */}
//       {Data?.Product?.length > 0 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.secondPageBackground} />
//           <View style={styles.secondPageTopContainer} />
//           <View style={styles.secondPageBottomRoundOne} />
//           <View style={styles.secondPageBottomRoundTwo} />
//           <View style={styles.secondPageTopUpperContainer} />
//           <View style={styles.secondPageImageContainer}>
//             <Image
//               style={styles.secondPageImage}
//               src={
//                 Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                   ? Data?.Product?.[0]?.image
//                   : Data?.Product?.[0]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.secondPageProductPriceContainer}>
//             <Text style={styles.secondPageProductPrice}>
//               {Data?.Product?.[0]?.price} Rs.
//             </Text>
//           </View>
//           <View style={styles.secondPageBottomContentContainer}>
//             <Text style={styles.secondPageProductName}>
//               {Data?.Product?.[0]?.title}
//             </Text>
//             <Text style={styles.secondPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}

//       {/* Third Page */}
//       {Data?.Product?.length > 1 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.thirdPageLeftBackground} />
//           <View style={styles.thirdPageRightBackground} />

//           <View style={styles.thirdPageBottomRoundOne} />
//           <View style={styles.thirdPageBottomRoundTwo} />
//           <View style={styles.thirdPageBottomShapeContainer}>
//             <Image
//               style={styles.thirdPageBottomShape}
//               src="/image/shape2.png"
//             />
//           </View>
//           <View style={styles.thirdPageImageContainer}>
//             <Image
//               style={styles.thirdPageImage}
//               src={
//                 Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                   ? Data?.Product?.[1]?.image
//                   : Data?.Product?.[1]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.thirdPageProductPriceContainer}>
//             <Text style={styles.thirdPageProductPrice}>
//               {Data?.Product?.[1]?.price} Rs.
//             </Text>
//           </View>
//           <View style={styles.thirdPageBottomContentContainer}>
//             <Text style={styles.thirdPageProductName}>
//               {Data?.Product?.[1]?.title}
//             </Text>
//             <Text style={styles.thirdPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* Fourth Page */}
//       {Data?.Product?.length > 2 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.fourthPageTopBackground} />
//           <View style={styles.fourthPageBottomBackground} />

//           <View style={styles.fourthPageBottomRoundOne} />
//           <View style={styles.fourthPageBottomRoundTwo} />
//           <View style={styles.fourthPageBottomShapeContainer}>
//             <Image
//               style={styles.fourthPageBottomShape}
//               src="/image/shape2.png"
//             />
//           </View>
//           <View style={styles.fourthPageImageContainer}>
//             <Image
//               style={styles.fourthPageImage}
//               src={
//                 Data?.Product?.[2]?.image && Data?.Product?.[2]?.image !== "N/A"
//                   ? Data?.Product?.[2]?.image
//                   : Data?.Product?.[2]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.fourthPageTopRoundOne} />
//           <View style={styles.fourthPageTopRoundTwo} />
//           <View style={styles.fourthPageProductPriceContainer}>
//             <Text style={styles.fourthPageProductPrice}>
//               {Data?.Product?.[2]?.price} Rs.
//             </Text>
//           </View>

//           <View style={styles.fourthPageProductNameContainer}>
//             <Text style={styles.fourthPageProductName}>
//               {Data?.Product?.[2]?.title}
//             </Text>
//           </View>
//           <View style={styles.fourthPageProdutDescriptionContainer}>
//             <Text style={styles.fourthPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}

//       {/* Fifth Page */}
//       {Data?.Product?.length > 3 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.fifthPageBackground} />
//           <View style={styles.fifthPageRightBackground} />

//           <View style={styles.fifthPageTopRoundOne} />
//           <View style={styles.fifthPageTopRoundTwo} />
//           <View style={styles.fifthPageTopShapeContainer}>
//             <Image style={styles.fifthPageTopShape} src="/image/shape1.png" />
//           </View>
//           <View style={styles.fifthPageImageContainer}>
//             <Image
//               style={styles.fifthPageImage}
//               src={
//                 Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                   ? Data?.Product?.[3]?.image
//                   : Data?.Product?.[3]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.fifthPageProductPriceContainer}>
//             <Text style={styles.fifthPageProductPrice}>
//               {Data?.Product?.[3]?.price} Rs.
//             </Text>
//           </View>
//           <View style={styles.fifthPageContentContainer}>
//             <Text style={styles.fifthPageProductName}>
//               {Data?.Product?.[3]?.title}
//             </Text>
//             <Text style={styles.fifthPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* Sixth Page */}
//       {Data?.Product?.length > 4 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.sixthPageTopBackground} />
//           <View style={styles.sixthPageBottomBackground} />

//           <View style={styles.sixthPageBottomShapeContainer}>
//             <Image
//               style={styles.sixthPageBottomShape}
//               src="/image/shape2.png"
//             />
//           </View>
//           <View style={styles.sixthPageImageContainer}>
//             <Image
//               style={styles.sixthPageImage}
//               src={
//                 Data?.Product?.[4]?.image && Data?.Product?.[4]?.image !== "N/A"
//                   ? Data?.Product?.[4]?.image
//                   : Data?.Product?.[4]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.sixthPageBottomRoundOne} />
//           <View style={styles.sixthPageBottomRoundTwo} />
//           <View style={styles.sixthPageTopRoundOne} />
//           <View style={styles.sixthPageTopRoundTwo} />
//           <View style={styles.sixthPageProductPriceContainer}>
//             <Text style={styles.sixthPageProductPrice}>
//               {Data?.Product?.[4]?.price} Rs.
//             </Text>
//           </View>

//           <View style={styles.sixthPageProductNameContainer}>
//             <Text style={styles.sixthPageProductName}>
//               {Data?.Product?.[4]?.title}
//             </Text>
//           </View>
//           <View style={styles.sixthPageProdutDescriptionContainer}>
//             <Text style={styles.sixthPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* Seventh Page */}
//       {Data?.Product?.length > 5 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.seventhPageLeftUpperBackground} />
//           <View style={styles.seventhPageLeftBottomBackground} />
//           <View style={styles.seventhPageRightBackground} />

//           <View style={styles.seventhPageTopShapeContainer}>
//             <Image style={styles.seventhPageTopShape} src="/image/shape1.png" />
//           </View>
//           <View style={styles.seventhPageImageContainer}>
//             <Image
//               style={styles.seventhPageImage}
//               src={
//                 Data?.Product?.[5]?.image && Data?.Product?.[5]?.image !== "N/A"
//                   ? Data?.Product?.[5]?.image
//                   : Data?.Product?.[5]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.seventhPageTopRoundOne} />
//           <View style={styles.seventhPageTopRoundTwo} />
//           <View style={styles.seventhPageProductPriceContainer}>
//             <Text style={styles.seventhPageProductPrice}>
//               {Data?.Product?.[5]?.price} Rs.
//             </Text>
//           </View>
//           <View style={styles.seventhPageContentContainer}>
//             <Text style={styles.seventhPageProductName}>
//               {Data?.Product?.[5]?.title}
//             </Text>
//             <Text style={styles.seventhPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* eight Page */}
//       {Data?.Product?.length > 6 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.eightPageLeftBackground} />
//           <View style={styles.eightPageRightBackground} />
//           <View style={styles.eightPageTopShapeContainer}>
//             <Image style={styles.eightPageTopShape} src="/image/shape1.png" />
//           </View>
//           <View style={styles.eightPageImageContainer}>
//             <Image
//               style={styles.eightPageImage}
//               src={
//                 Data?.Product?.[6]?.image && Data?.Product?.[6]?.image !== "N/A"
//                   ? Data?.Product?.[6]?.image
//                   : Data?.Product?.[6]?.productImage // Fallback to productImage
//               }
//             />
//           </View>
//           <View style={styles.eightPageTopRoundOne} />
//           <View style={styles.eightPageTopRoundTwo} />

//           <View style={styles.eightPageContentContainer}>
//             <Text style={styles.eightPageProductName}>
//               {Data?.Product?.[6]?.title}
//             </Text>
//             <Text style={styles.eightPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//             <Text style={styles.eightPageProductPrice}>
//               {Data?.Product?.[6]?.price} Rs.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* ninth Page */}
//       {Data?.Product?.length > 7 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.ninthPageBackground} />
//           <View style={styles.ninthPageTopRoundOne} />
//           <View style={styles.ninthPageTopRoundTwo} />
//           <View style={styles.ninthPageBottomShapeContainer}>
//             <Image style={styles.ninthPageTopShape} src="/image/shape1.png" />
//           </View>
//           <View style={styles.ninthPageImageContainer}>
//             <Image
//               style={styles.ninthPageImage}
//               src={
//                 Data?.Product?.[7]?.image && Data?.Product?.[7]?.image !== "N/A"
//                   ? Data?.Product?.[7]?.image
//                   : Data?.Product?.[7]?.productImage // Fallback to productImage
//               }
//             />
//           </View>

//           <View style={styles.ninthPageContentContainer}>
//             <Text style={styles.ninthPageProductName}>
//               {Data?.Product?.[7]?.title}
//             </Text>
//             <Text style={styles.ninthPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products.
//             </Text>
//             <Text style={styles.ninthPageProductPrice}>
//               {Data?.Product?.[7]?.price} Rs.
//             </Text>
//           </View>
//         </Page>
//       )}

//       <Page size="A4" style={styles.page}>
//         <View style={styles.lastPageTopBackground} />
//         <View style={styles.lastPageBackground} />

//         <View style={styles.lastPageContentContainer}>
//           <View style={styles.lastPageLogoImageContainer}>
//             <Image
//               style={styles.lastPageLogoImage}
//               src="/blackberrysLogo.png"
//             />
//           </View>

//           <View style={styles.lastPageManagerDetailsContainer}>
//             <View style={styles.lastPageManagerNameContainer}>
//               <Text>{Data?.Store?.storename}</Text>
//             </View>
//             <View style={styles.lastPageManagerNumberContainer}>
//               <Text>{Data?.Store?.storePhone}</Text>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// }

// export default TailoredTrends;














import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  // Font,
  // PDFViewer,
  // Link,
} from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    position: "relative",
  },
  loyaltyContainer: {
    position: "absolute",
    right: 0,
    top: "45%",
    transform: "rotate(-90deg)",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  loyaltyPointsImage: {
    width: 50,
    height: 50,
    marginRight: 10,
  },
  loyaltyPoints: {
    fontSize: 16,
    color: "#FFFFFF",
    fontWeight: "bold",
  },
  firstPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#5b5f62",
  },
  firstPageTopRoundOne: {
    position: "absolute",
    top: "-200px",
    left: "-520px",
    width: "700px",
    height: "700px",
    borderRadius: "100%",
    border: "4px solid #728478",
  },
  firstPageTopRoundTwo: {
    position: "absolute",
    top: "-300px",
    left: "-500px",
    width: "700px",
    height: "700px",
    borderRadius: "100%",
    border: "2.5px solid #728478",
  },
  firstPageTopRoundThree: {
    position: "absolute",
    top: "-270px",
    left: "-600px",
    width: "750px",
    height: "750px",
    borderRadius: "100%",
    border: "2px solid #728478",
  },
  firstPageUpperLeftContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "65%",
    height: "70%",
    backgroundColor: "#e4d0c5",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  firstPageMainImageContainer: {
    height: "85%",
    width: "85%",
    border: "10px solid white",
  },
  firstPageMainImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  logoImageContainer: {
    position: "relative",
    top: "10%",
    left: "80%",
    width: "20%",
    height: "8%",
    backgroundColor: "#e4d0c5",
    padding: "2px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  logoImage: {
    width: "70%",
    height: "auto",
    objectFit: "cover",
    marginLeft: "15%",
  },
  firstPageUpperContainer: {
    position: "absolute",
    top: 0,
    right: "10%",
    backgroundColor: "#f8d4c1",
    width: "60%",
    height: "10%",
  },
  firstPageTopLine: {
    height: "1px",
    backgroundColor: "black",
    width: "80%",
    position: "absolute",
    top: "10%",
    left: "10%",
  },
  firstPageContentBox: {
    position: "absolute",
    bottom: "10%",
    left: "10%",
    width: "80%",
    height: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "left",
    margin: "auto",
  },
  greetingContainer: {
    position: "absolute",
    left: "50%",
    top: "20%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px 20px 10px 10px",
  },
  greeting: {
    fontSize: 35,
    fontWeight: "bold",
  },
  customerNameContainer: {
    position: "absolute",
    left: "50%",
    top: "28%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px 10px 10px 10px",
  },
  customerName: {
    fontSize: 40,
    fontWeight: "bold",
  },
  customerMessageContainer: {
    position: "absolute",
    left: "10%",
    top: "75%",
    color: "white",
    width: "35%",
    height: "20%",
  },
  customerMessage: {
    fontSize: 15,
  },
  firstPageBottomRightContainer: {
    position: "absolute",
    bottom: 0,
    right: 0,
    backgroundColor: "#728478",
    width: "50%",
    height: "35%",
  },
  firstPageBottomShapeContainer: {
    position: "absolute",
    bottom: "-80px",
    right: "-150px",
    width: "70%",
    height: "25%",
    transform: "rotate(180deg)",
  },
  firstPageBottomRoundOne: {
    position: "absolute",
    bottom: "-260px",
    right: "-350px",
    width: "500px",
    height: "500px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  firstPageBottomRoundTwo: {
    position: "absolute",
    bottom: "-460px",
    right: "-390px",
    width: "700px",
    height: "700px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },

  // NEW MRP STYLES - ONLY NUMBER STRIKETHROUGH
  mrpText: {
    color: "#eeefea",
    fontWeight: "bold",
    fontSize: 15,
  },
  mrpNumber: {
    color: "#eeefea",
    fontWeight: "bold",
    fontSize: 15,
    textDecoration: "line-through", // ✅ ONLY NUMBER CUT
  },
  priceRowContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
  },

  // For Second Page =>
  secondPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#efe6dc",
  },
  secondPageTopContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "80%",
    height: "60%",
    backgroundColor: "#728478",
  },
  secondPageImageContainer: {
    position: "relative",
    left: "10%",
    top: "10%",
    width: "60%",
    height: "60%",
    border: "10px solid #efe6dc",
  },
  secondPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  secondPageProductPriceContainer: {
    position: "absolute",
    right: "5%",
    top: "30%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  secondPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  secondPageBottomContentContainer: {
    position: "absolute",
    top: "72%",
    left: "10%",
    width: "50%",
    height: "25%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  secondPageProductName: {
    fontSize: 25,
  },
  secondPageProdutDescription: {
    fontSize: 15,
  },
  secondPageBottomRoundOne: {
    position: "absolute",
    top: "-350px",
    left: "-500px",
    width: "1100px",
    height: "1100px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  secondPageBottomRoundTwo: {
    position: "absolute",
    top: "-350px",
    left: "-100px",
    width: "900px",
    height: "900px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },
  secondPageTopUpperContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "50%",
    height: "30%",
    backgroundColor: "#5b6066",
  },

  // For third Page =>
  thirdPageLeftBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "40%",
    height: "100%",
    backgroundColor: "#efe6dc",
  },
  thirdPageRightBackground: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "60%",
    height: "100%",
    backgroundColor: "#c4ad95",
  },
  thirdPageImageContainer: {
    position: "relative",
    left: "50%",
    top: "10%",
    width: "40%",
    height: "50%",
    border: "10px solid #efe6dc",
  },
  thirdPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  thirdPageProductPriceContainer: {
    position: "absolute",
    left: "10%",
    top: "30%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  thirdPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  thirdPageBottomContentContainer: {
    position: "absolute",
    top: "65%",
    left: "10%",
    width: "60%",
    height: "30%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  thirdPageProductName: {
    fontSize: 25,
  },
  thirdPageProdutDescription: {
    fontSize: 15,
  },
  thirdPageBottomRoundOne: {
    position: "absolute",
    bottom: "-350px",
    right: "-670px",
    width: "1100px",
    height: "1100px",
    borderRadius: "100%",
    border: "2px solid #728478",
  },
  thirdPageBottomRoundTwo: {
    position: "absolute",
    bottom: "-400px",
    right: "-2000px",
    width: "2200px",
    height: "2200px",
    borderRadius: "100%",
    border: "5px solid #728478",
  },
  thirdPageBottomShapeContainer: {
    position: "absolute",
    bottom: "-250px",
    left: "25%",
    width: "50%",
    height: "40%",
    transform: "rotate(70deg)",
  },

  // For fourth Page =>
  fourthPageTopBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#efe6dc",
  },
  fourthPageBottomBackground: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#c4ad95",
  },
  fourthPageImageContainer: {
    position: "relative",
    left: "10%",
    top: "10%",
    width: "92%",
    height: "50%",
    border: "10px solid #efe6dc",
  },
  fourthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fourthPageProductPriceContainer: {
    position: "absolute",
    left: "10%",
    top: "20%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  fourthPageProductNameContainer: {
    position: "absolute",
    left: "10%",
    top: "30%",
    width: "80%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  fourthPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  fourthPageProdutDescriptionContainer: {
    position: "absolute",
    top: "65%",
    left: "10%",
    width: "80%",
    height: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  fourthPageProductName: {
    fontSize: 25,
  },
  fourthPageProdutDescription: {
    fontSize: 15,
  },
  fourthPageTopRoundOne: {
    position: "absolute",
    top: "-400px",
    right: "-750px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  fourthPageTopRoundTwo: {
    position: "absolute",
    top: "-450px",
    right: "-650px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },
  fourthPageBottomRoundOne: {
    position: "absolute",
    bottom: "-350px",
    left: "-670px",
    width: "1100px",
    height: "1100px",
    borderRadius: "100%",
    border: "2px solid #728478",
  },
  fourthPageBottomRoundTwo: {
    position: "absolute",
    bottom: "-300px",
    left: "-250px",
    width: "700px",
    height: "600px",
    borderRadius: "100%",
    border: "5px solid #728478",
  },
  fourthPageBottomShapeContainer: {
    position: "absolute",
    bottom: "-200px",
    left: "-100px",
    width: "50%",
    height: "40%",
    transform: "rotate(70deg)",
  },

  // For Fifth Page =>
  fifthPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#efe6dc",
  },
  fifthPageRightBackground: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "45%",
    height: "70%",
    backgroundColor: "#728478",
  },
  fifthPageImageContainer: {
    position: "relative",
    left: 0,
    top: "50%",
    width: "90%",
    height: "40%",
    border: "10px solid #efe6dc",
  },
  fifthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fifthPageProductPriceContainer: {
    position: "absolute",
    top: "10%",
    right: "25%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  fifthPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  fifthPageContentContainer: {
    position: "absolute",
    top: "10%",
    left: "10%",
    width: "40%",
    height: "30%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  fifthPageProductName: {
    fontSize: 25,
  },
  fifthPageProdutDescription: {
    fontSize: 15,
  },
  fifthPageTopRoundOne: {
    position: "absolute",
    top: "-400px",
    right: "-750px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  fifthPageTopRoundTwo: {
    position: "absolute",
    top: "-450px",
    right: "-650px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },
  fifthPageTopShapeContainer: {
    position: "absolute",
    top: "-150px",
    right: "-120px",
    width: "50%",
    height: "40%",
    transform: "rotate(120deg)",
  },

  // For sixth Page =>
  sixthPageTopBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#dfcdc1",
  },
  sixthPageBottomBackground: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#eae7dc",
  },
  sixthPageImageContainer: {
    position: "relative",
    left: "10%",
    top: "10%",
    width: "50%",
    height: "70%",
    border: "10px solid #efe6dc",
  },
  sixthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  sixthPageProductPriceContainer: {
    position: "absolute",
    left: "45%",
    top: "50%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
  },
  sixthPageProductNameContainer: {
    position: "absolute",
    left: "45%",
    top: "60%",
    backgroundColor: "#323230",
    color: "#eeefea",
    padding: "10px",
    width: "50%",
  },
  sixthPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  sixthPageProdutDescriptionContainer: {
    position: "absolute",
    top: "20%",
    left: "65%",
    width: "30%",
    display: "flex",
    justifyContent: "center",
  },
  sixthPageProductName: {
    fontSize: 25,
  },
  sixthPageProdutDescription: {
    fontSize: 15,
  },
  sixthPageTopRoundOne: {
    position: "absolute",
    top: "-400px",
    right: "-750px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  sixthPageTopRoundTwo: {
    position: "absolute",
    top: "-450px",
    right: "-650px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },
  sixthPageBottomRoundOne: {
    position: "absolute",
    bottom: "-150px",
    left: "-300px",
    width: "600px",
    height: "600px",
    borderRadius: "100%",
    border: "2px solid #728478",
  },
  sixthPageBottomRoundTwo: {
    position: "absolute",
    bottom: "0px",
    left: "-350px",
    width: "500px",
    height: "500px",
    borderRadius: "100%",
    border: "5px solid #728478",
  },
  sixthPageBottomShapeContainer: {
    position: "absolute",
    bottom: "5%",
    left: "5%",
    width: "80%",
    height: "30%",
  },

  // For seventh Page =>
  seventhPageLeftUpperBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "65%",
    height: "20%",
    backgroundColor: "#dfcdc1",
  },
  seventhPageLeftBottomBackground: {
    position: "absolute",
    top: "20%",
    left: 0,
    width: "65%",
    height: "80%",
    backgroundColor: "#efe6dc",
  },
  seventhPageRightBackground: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "45%",
    height: "100%",
    backgroundColor: "#728478",
  },
  seventhPageImageContainer: {
    position: "relative",
    left: "-10px",
    top: "10%",
    width: "80%",
    height: "40%",
    border: "10px solid #efe6dc",
  },
  seventhPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  seventhPageProductPriceContainer: {
    position: "absolute",
    top: "70%",
    right: "10%",
    color: "#eeefea",
    padding: "10px",
  },
  seventhPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  seventhPageContentContainer: {
    position: "absolute",
    top: "55%",
    left: "5%",
    width: "45%",
    height: "40%",
    display: "flex",
    justifyContent: "space-evenly",
    backgroundColor: "#5b5f62",
    color: "#eeefea",
    padding: "20px",
  },
  seventhPageProductName: {
    fontSize: 25,
  },
  seventhPageProdutDescription: {
    fontSize: 15,
  },
  seventhPageTopRoundOne: {
    position: "absolute",
    top: "-400px",
    right: "-750px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #5b5f62",
  },
  seventhPageTopRoundTwo: {
    position: "absolute",
    top: "-450px",
    right: "-650px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #5b5f62",
  },
  seventhPageTopShapeContainer: {
    position: "absolute",
    top: "0%",
    right: "-180px",
    width: "50%",
    height: "40%",
    transform: "rotate(80deg)",
  },

  // For eight Page =>
  eightPageleftBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "70%",
    height: "100%",
    backgroundColor: "#f5efe3",
  },
  eightPageRightBackground: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    height: "100%",
    backgroundColor: "#5b5f62",
  },
  eightPageImageContainer: {
    position: "relative",
    left: "10%",
    top: "10%",
    width: "50%",
    height: "50%",
    border: "10px solid white",
  },
  eightPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  eightPageProductPriceContainer: {
    position: "absolute",
    top: "70%",
    right: "10%",
    color: "#eeefea",
    padding: "10px",
  },
  eightPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  eightPageContentContainer: {
    position: "absolute",
    top: "65%",
    right: 0,
    width: "80%",
    height: "25%",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#728478",
    color: "#eeefea",
    padding: "20px 200px 20px 20px",
  },
  eightPageProductName: {
    fontSize: 25,
  },
  eightPageProdutDescription: {
    fontSize: 15,
  },
  eightPageTopRoundOne: {
    position: "absolute",
    top: "-400px",
    right: "-750px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #e7d3c5",
  },
  eightPageTopRoundTwo: {
    position: "absolute",
    top: "-450px",
    right: "-650px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #e7d3c5",
  },
  eightPageTopShapeContainer: {
    position: "absolute",
    top: "-140px",
    right: "-100px",
    width: "70%",
    height: "25%",
    transform: "rotate(180deg)",
  },

  // For ninth Page =>
  ninthPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#5b5f62",
  },
  ninthPageImageContainer: {
    position: "relative",
    left: "10%",
    top: "10%",
    width: "80%",
    height: "80%",
    border: "10px solid white",
  },
  ninthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  ninthPageProductPriceContainer: {
    position: "absolute",
    top: "70%",
    right: "10%",
    color: "#eeefea",
    padding: "10px",
  },
  ninthPageProductPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#eeefea",
  },
  ninthPageContentContainer: {
    position: "absolute",
    top: "55%",
    left: 0,
    width: "60%",
    height: "30%",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#728478",
    color: "#eeefea",
    padding: "20px 20px 20px 60px",
  },
  ninthPageProductName: {
    fontSize: 25,
  },
  ninthPageProdutDescription: {
    fontSize: 15,
  },
  ninthPageTopRoundOne: {
    position: "absolute",
    top: "-600px",
    left: "-130px",
    width: "900px",
    height: "1000px",
    borderRadius: "100%",
    border: "5px solid #efe6dc",
  },
  ninthPageTopRoundTwo: {
    position: "absolute",
    top: "-650px",
    left: "-250px",
    width: "900px",
    height: "950px",
    borderRadius: "100%",
    border: "2px solid #efe6dc",
  },
  ninthPageBottomShapeContainer: {
    position: "absolute",
    bottom: "-100px",
    right: "-100px",
    width: "70%",
    height: "25%",
    transform: "rotate(180deg)",
  },

  // Last Page
  lastPageTopBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#efe6dc",
  },
  lastPageBackground: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50%",
    backgroundColor: "#c4ad95",
  },
  lastPageContentContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    gap: 15,
  },
  lastPageLogoImageContainer: {
    width: 100,
    height: "auto",
    marginBottom: 10,
  },
  lastPageLogoImage: {
    width: "100%",
    height: "auto",
  },
  lastPageManagerDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    fontSize: 14,
    gap: 5,
  },
  lastPageManagerNameContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 30,
  },
  lastPageManagerNumberContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 30,
  },
  lastPageStoreDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    fontSize: 14,
    marginTop: 10,
  },
  lastpageCopyright: {
    marginTop: 20,
    fontSize: 10,
    textAlign: "center",
  },
  socialLinks: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 10,
    marginTop: 40,
  },
  icon: {
    width: 24,
    height: 24,
  },
});

function TailoredTrends({ jsonData, vendor }) {
  const [Data, setData] = useState();

  useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  console.log("This is the data of TailoredTrends :=>", Data);
  console.log(
    "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
    Data?.Product?.[0]?.image
  );

  // Helper function to format price without decimals
  const formatPrice = (price) => {
    return Math.floor(price).toString();
  };

  // Product description
  const productDescription = "Experience the perfect blend of quality and style with our thoughtfully crafted products.";

  return (
    <Document>
      {/* FIRST PAGE - UNCHANGED */}
      <Page size="A4" style={styles.page}>
        <View style={styles.firstPageBackground} />
        <View style={styles.firstPageBottomRightContainer} />
        <View style={styles.firstPageBottomShapeContainer}>
          <Image style={styles.firstPageBottomShape} src="/image/shape1.png" />
        </View>
        <View style={styles.firstPageUpperLeftContainer}>
          <View style={styles.firstPageMainImageContainer}>
            <Image
              style={styles.firstPageMainImage}
              src="/image/frontPageImage.jpg"
            />
          </View>
        </View>
        <View style={styles.logoImageContainer}>
          <Image style={styles.logoImage} src="/blackberrysLogo.png" />
        </View>
        <View style={[styles.greetingContainer]}>
          <Text style={styles.greeting}>Hello, </Text>
        </View>
        <View style={[styles.loyaltyContainer]}>
          <Image
            style={styles.loyaltyPointsImage}
            src="/loyaltyPointsWhite.png"
          />
          <Text style={styles.loyaltyPoints}>25 loyaltyPoints </Text>
        </View>
        <View style={[styles.customerNameContainer]}>
          <Text style={styles.customerName}>
            {Data?.Customer?.customerName}
          </Text>
        </View>
        <View style={[styles.customerMessageContainer]}>
          <Text style={styles.customerMessage}>
            Based on your interests and recent activities, we've carefully
            curated a range of items that we believe you'll love. Whether you're
            looking for something specific or just browsing, we hope you find
            inspiration within these pages.
          </Text>
        </View>
        <View style={styles.firstPageTopRoundOne} />
        <View style={styles.firstPageTopRoundTwo} />
        <View style={styles.firstPageTopRoundThree} />
        <View style={styles.firstPageBottomRoundOne} />
        <View style={styles.firstPageBottomRoundTwo} />
      </Page>

      {/* INFINITE DYNAMIC PRODUCT PAGES */}
      {Data?.Product?.map((product, index) => {
        const layoutIndex = index % 8; // 8 different layouts
        const imageSrc =
          product?.image && product?.image !== "N/A"
            ? product?.image
            : product?.productImage;
        const showMrp = product?.price !== product?.mrp;

        switch (layoutIndex) {
          case 0: // SECOND PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.secondPageBackground} />
                <View style={styles.secondPageTopContainer} />
                <View style={styles.secondPageBottomRoundOne} />
                <View style={styles.secondPageBottomRoundTwo} />
                <View style={styles.secondPageTopUpperContainer} />
                <View style={styles.secondPageImageContainer}>
                  <Image style={styles.secondPageImage} src={imageSrc} />
                </View>
                <View style={styles.secondPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.secondPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.secondPageBottomContentContainer}>
                  <Text style={styles.secondPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.secondPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 1: // THIRD PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.thirdPageLeftBackground} />
                <View style={styles.thirdPageRightBackground} />
                <View style={styles.thirdPageBottomRoundOne} />
                <View style={styles.thirdPageBottomRoundTwo} />
                <View style={styles.thirdPageBottomShapeContainer}>
                  <Image
                    style={styles.thirdPageBottomShape}
                    src="/image/shape2.png"
                  />
                </View>
                <View style={styles.thirdPageImageContainer}>
                  <Image style={styles.thirdPageImage} src={imageSrc} />
                </View>
                <View style={styles.thirdPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.thirdPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.thirdPageBottomContentContainer}>
                  <Text style={styles.thirdPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.thirdPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 2: // FOURTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.fourthPageTopBackground} />
                <View style={styles.fourthPageBottomBackground} />
                <View style={styles.fourthPageBottomRoundOne} />
                <View style={styles.fourthPageBottomRoundTwo} />
                <View style={styles.fourthPageBottomShapeContainer}>
                  <Image
                    style={styles.fourthPageBottomShape}
                    src="/image/shape2.png"
                  />
                </View>
                <View style={styles.fourthPageTopRoundOne} />
                <View style={styles.fourthPageTopRoundTwo} />
                <View style={styles.fourthPageImageContainer}>
                  <Image style={styles.fourthPageImage} src={imageSrc} />
                </View>
                <View style={styles.fourthPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.fourthPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.fourthPageProductNameContainer}>
                  <Text style={styles.fourthPageProductName}>
                    {product?.title}
                  </Text>
                </View>
                <View style={styles.fourthPageProdutDescriptionContainer}>
                  <Text style={styles.fourthPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 3: // FIFTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.fifthPageBackground} />
                <View style={styles.fifthPageRightBackground} />
                <View style={styles.fifthPageTopRoundOne} />
                <View style={styles.fifthPageTopRoundTwo} />
                <View style={styles.fifthPageTopShapeContainer}>
                  <Image style={styles.fifthPageTopShape} src="/image/shape1.png" />
                </View>
                <View style={styles.fifthPageImageContainer}>
                  <Image style={styles.fifthPageImage} src={imageSrc} />
                </View>
                <View style={styles.fifthPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.fifthPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.fifthPageContentContainer}>
                  <Text style={styles.fifthPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.fifthPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 4: // SIXTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.sixthPageTopBackground} />
                <View style={styles.sixthPageBottomBackground} />
                <View style={styles.sixthPageBottomShapeContainer}>
                  <Image
                    style={styles.sixthPageBottomShape}
                    src="/image/shape2.png"
                  />
                </View>
                <View style={styles.sixthPageImageContainer}>
                  <Image style={styles.sixthPageImage} src={imageSrc} />
                </View>
                <View style={styles.sixthPageBottomRoundOne} />
                <View style={styles.sixthPageBottomRoundTwo} />
                <View style={styles.sixthPageTopRoundOne} />
                <View style={styles.sixthPageTopRoundTwo} />
                <View style={styles.sixthPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.sixthPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.sixthPageProductNameContainer}>
                  <Text style={styles.sixthPageProductName}>
                    {product?.title}
                  </Text>
                </View>
                <View style={styles.sixthPageProdutDescriptionContainer}>
                  <Text style={styles.sixthPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 5: // SEVENTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.seventhPageLeftUpperBackground} />
                <View style={styles.seventhPageLeftBottomBackground} />
                <View style={styles.seventhPageRightBackground} />
                <View style={styles.seventhPageTopShapeContainer}>
                  <Image style={styles.seventhPageTopShape} src="/image/shape1.png" />
                </View>
                <View style={styles.seventhPageImageContainer}>
                  <Image style={styles.seventhPageImage} src={imageSrc} />
                </View>
                <View style={styles.seventhPageTopRoundOne} />
                <View style={styles.seventhPageTopRoundTwo} />
                <View style={styles.seventhPageProductPriceContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.seventhPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.seventhPageContentContainer}>
                  <Text style={styles.seventhPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.seventhPageProdutDescription}>
                    {productDescription}
                  </Text>
                </View>
              </Page>
            );

          case 6: // EIGHTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.eightPageleftBackground} />
                <View style={styles.eightPageRightBackground} />
                <View style={styles.eightPageTopShapeContainer}>
                  <Image style={styles.eightPageTopShape} src="/image/shape1.png" />
                </View>
                <View style={styles.eightPageImageContainer}>
                  <Image style={styles.eightPageImage} src={imageSrc} />
                </View>
                <View style={styles.eightPageTopRoundOne} />
                <View style={styles.eightPageTopRoundTwo} />
                <View style={styles.eightPageContentContainer}>
                  <Text style={styles.eightPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.eightPageProdutDescription}>
                    {productDescription}
                  </Text>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.eightPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          case 7: // NINTH PAGE LAYOUT
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.ninthPageBackground} />
                <View style={styles.ninthPageTopRoundOne} />
                <View style={styles.ninthPageTopRoundTwo} />
                <View style={styles.ninthPageBottomShapeContainer}>
                  <Image style={styles.ninthPageTopShape} src="/image/shape1.png" />
                </View>
                <View style={styles.ninthPageImageContainer}>
                  <Image style={styles.ninthPageImage} src={imageSrc} />
                </View>
                <View style={styles.ninthPageContentContainer}>
                  <Text style={styles.ninthPageProductName}>
                    {product?.title}
                  </Text>
                  <Text style={styles.ninthPageProdutDescription}>
                    {productDescription}
                  </Text>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.ninthPageProductPrice}>
                      {formatPrice(product?.price)} Rs.
                    </Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          default:
            return null;
        }
      })}

      {/* LAST PAGE - UNCHANGED */}
      <Page size="A4" style={styles.page}>
        <View style={styles.lastPageTopBackground} />
        <View style={styles.lastPageBackground} />
        <View style={styles.lastPageContentContainer}>
          <View style={styles.lastPageLogoImageContainer}>
            <Image
              style={styles.lastPageLogoImage}
              src="/blackberrysLogo.png"
            />
          </View>
          <View style={styles.lastPageManagerDetailsContainer}>
            <View style={styles.lastPageManagerNameContainer}>
              <Text>{Data?.Store?.storename}</Text>
            </View>
            <View style={styles.lastPageManagerNumberContainer}>
              <Text>{Data?.Store?.storePhone}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default TailoredTrends;